import { ComponentProps } from "react";

const FullScreenLoader = (props: ComponentProps<"div">) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-background"
      {...props}
    >
      <div className="flex space-x-4">
        <div className="h-4 w-4 animate-loader rounded-full bg-foreground opacity-60"></div>
        <div className="h-4 w-4 animate-loader rounded-full bg-foreground opacity-75 delay-150"></div>
        <div className="h-4 w-4 animate-loader rounded-full bg-foreground opacity-80 delay-300"></div>
      </div>
    </div>
  );
};

export { FullScreenLoader };
